<template>
  <div>
    <div
        v-for="item of selectOptions"
        :key="item.select"
        :class="{ 'background-red': showSelectSpec }"
        class="row no-gutters"
    >
      <div class="col-sm-2">
        <div class="opacity-50 my-2">{{ item.select }}</div>
      </div>
      <div class="col-sm-10">
        <div class="aiz-radio-inline">
          <label
              v-for="option in item.options"
              :key="option"
              :class="{ disabled: isOptionDisabled(item.select, option) }"
              class="aiz-megabox pl-0 mr-2"
              @click="onClickOption(item.select, option)"
              @mouseenter="onHoverOption(item.select, option)"
          >
            <span
                :class="{ checked: isOptionChecked(item.select, option) }"
                class="aiz-megabox-elem rounded d-flex align-items-center justify-content-center py-2 px-3 mb-2 user-select-none"
            >
              {{ option }}
            </span>
          </label>
        </div>
      </div>
    </div>
    <div
        v-if="showSelectSpec"
        class="row no-gutters background-red"
        style="color: #ff424f;"
    >
      {{ $t("请先选择商品规格") }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    goods: Object,
    showSelectSpec: Boolean
  },
  data() {
    const selectOptions = this.parseSkuData(this.goods.specs);
    const curSelects = {};
    for (const { select } of selectOptions) {
      curSelects[select] = undefined;
    }
    return {
      selectOptions,
      curSelects
    };
  },
  async created() {
    // 确保默认选中第一个规格
    if (this.goods.specs && this.goods.specs.length > 0) {
      const firstSpec = this.goods.specs[0]; // 获取第一个规格
      const firstSelectAndOptions = JSON.parse(firstSpec.skuData);

      // 遍历每个规格，设置默认选中值
      firstSelectAndOptions.forEach(({ select, option }) => {
        if (!this.curSelects[select]) {
          this.curSelects[select] = option;
        }
      });

      // 触发默认选中事件
      this.emitDefaultSelect();
    }
  },
  methods: {
    emitDefaultSelect() {
      const selectedSpec = this.goods.specs.find(spec => {
        const data = JSON.parse(spec.skuData);
        return data.every(
            ({ select, option }) => this.curSelects[select] === option
        );
      });

      // 触发 select 事件，通知父组件
      this.$emit("select", selectedSpec);
    },
    parseSkuData(specs) {
      const list = [];
      specs.forEach(spec => {
        const selectAndOptionList = JSON.parse(spec.skuData);
        selectAndOptionList.forEach(({ select, option }) => {
          const item = list.find(item => item.select === select);
          if (item) {
            if (!item.options.includes(option)) {
              item.options.push(option);
            }
          } else {
            list.push({ select, options: [option] });
          }
        });
      });
      return list;
    },
    optionEnable(select, option) {
      const combineSelects = { ...this.curSelects, [select]: option };
      return this.goods.specs.some(spec => {
        const selects = JSON.parse(spec.skuData);
        return Object.entries(combineSelects)
            .filter(([_, option]) => option !== undefined)
            .every(([select, option]) =>
                selects.find(
                    item => item.select === select && item.option === option
                )
            );
      });
    },
    isOptionDisabled(select, option) {
      return !this.optionEnable(select, option);
    },
    isOptionChecked(select, option) {
      return this.curSelects[select] === option;
    },
    onClickOption(select, option) {
      if (this.isOptionDisabled(select, option)) return;
      if (this.curSelects[select] === option) {
        this.curSelects[select] = undefined;
      } else {
        this.curSelects[select] = option;
      }
      this.onHoverOption(select, option);
      const spec = this.goods.specs.find(spec => {
        const data = JSON.parse(spec.skuData);
        return data.every(
            ({select, option}) => this.curSelects[select] === option
        );
      });
      this.$emit("select", spec);
    },
    onHoverOption(select, option) {
      try {
        const pic = JSON.parse(this.goods.optionPics)[select][option];
        if (pic) {
          this.$emit("hover", pic);
        }
      } catch (e) {
      }
    }
  }
};
</script>
<style scoped>
.disabled {
  color: rgba(0, 0, 0, 0.26);
  cursor: not-allowed;
}

.aiz-megabox .aiz-megabox-elem.checked {
  border-color: var(--primary);
}

.background-red {
  background: #fff5f5;
}
</style>
